import { Link } from "react-router-dom";

import "./Footer.css";
import { SITE } from "../../data/site";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <p className="footer-name">Konstantinos Efkarpidis</p>
          <p className="footer-role">
            Mobile developer · React Native &amp; Expo
          </p>
        </div>

        <nav className="footer-nav" aria-label="Footer">
          <div className="footer-col">
            <p className="footer-col-title">Site</p>
            <Link to="/">Home</Link>
            <Link to="/apps">Apps</Link>
          </div>
          <div className="footer-col">
            <p className="footer-col-title">Apps</p>
            <Link to="/apps/shoplist">ShopList</Link>
            <Link to="/apps/stack-clash">Stack Clash</Link>
          </div>
          <div className="footer-col">
            <p className="footer-col-title">Elsewhere</p>
            <a href={SITE.github} target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
            <a href={SITE.linkedin} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </div>
          <div className="footer-col">
            <p className="footer-col-title">Legal</p>
            <Link to="/privacy">ShopList Privacy</Link>
            <Link to="/stackClash/privacy">Stack Clash Privacy</Link>
          </div>
        </nav>
      </div>

      <div className="container footer-bottom">
        <p>
          © {new Date().getFullYear()} Konstantinos Efkarpidis. Designed and
          built by hand.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
